// extracted by mini-css-extract-plugin
module.exports = {"figure":"item-module--figure--1CxAL","animatename":"item-module--animatename--2K8j1","imgBox":"item-module--img-box--krUHy","imgNum":"item-module--img-num--1Auhg"};